import { render } from "./ShopDetails.vue?vue&type=template&id=fe104004&ts=true"
import script from "./ShopDetails.vue?vue&type=script&lang=ts"
export * from "./ShopDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__